import React from "react";
import { Radar } from "react-chartjs-2";
import { Construct_code_category } from "../Constants.js";
import "../../styles/global.css";
import "./Individual.css"; // custom styles for this page
import { 
    Chart as ChartJS, 
    RadialLinearScale, 
    PointElement, 
    LineElement, 
    Filler, 
    Tooltip, 
    Legend 
} from 'chart.js';

ChartJS.register(
    RadialLinearScale, 
    PointElement, 
    LineElement, 
    Filler, 
    Tooltip, 
    Legend
);

const order = [
  "Self-Efficacy",
  "Value",
  "Belongingness",
  "Cognitive Engagement",
  "Self-Regulation",
  "Withdrawal Intention",
  "Autonomy",
  "Behavioral Engagement",
  "Affective Engagement",
  "Academic Burden",
  "Intrinsic Motivation",
  "Extrinsic Motivation",
  "Cultural Congruity",
  "Relatedness"
];


const codeLabelMap = Construct_code_category.reduce((acc, item) => {
    acc[item.code] = item.construct;
    return acc;
}, {});

const RadarChart = ({ data, selectedStudent, avg }) => {
    const filtered = data.filter((d) => d.student_name === selectedStudent);

    const chartData = {
        // labels: filtered.map((d) => codeLabelMap[d.group_code]),
        // datasets: [
        //     {
        //         data: filtered.map((d) => d.avg_score),
        //         backgroundColor: "rgba(54, 163, 235, 0.01)",
        //         borderColor: "#c62828",
        //         borderWidth: 2,
        //         pointBackgroundColor: "#c62828"
        //     }
        // ]  
        labels: order,
        datasets: [
            {
                label: "Student",
                data: order.map(label => {
                    const constructObj = Construct_code_category.find(c => c.construct === label);
                    const code = constructObj?.code;
                    const score = filtered.find(d => d.group_code === code)?.avg_score;
                    return score ?? null;
                }),
                backgroundColor: "rgba(54, 163, 235, 0)",
                borderColor: "#c62828",
                borderWidth: 2,
                pointBackgroundColor: "#c62828",
                spanGaps: true,
            },
            {
                label: "Class Average",
                data: order.map(label => {
                    const constructObj = Construct_code_category.find(c => c.construct === label);
                    const code = constructObj?.code;
                    const score = avg.find(d => d.group_code === code)?.avg_score;
                    return score ?? null;
                }),
                backgroundColor: "rgba(54, 163, 235, 0)",
                borderColor: "#cdcdcd",
                borderWidth: 2,
                pointBackgroundColor: "#cdcdcd",
                spanGaps: true,
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            r: {
                min: 0,
                max: 6,
                ticks: {
                    stepSize: 1,
                },
                pointLabels: {
                    font: {
                        size: 13, // size for outer category labels
                    }
                }
            }
        },
        plugins: {
            legend: {
                display: true,
                position: 'right',
         
            },
            tooltip: {
                bodyFont: {
                    size: 14 // size for tooltip text
                },
                titleFont: {
                    size: 16
                }
            }
        }
    };

    return <Radar data={chartData} options={options} />;
};

export default RadarChart;